import React, { useState, useMemo, useRef } from 'react'
import {
  useMediaQuery,
  ThemeProvider,
} from '@mui/material'
import { theme } from '../../../config/Dashboardtheme'
import { InvitedAndActiveEmployeesSelector, resendInvite } from '../../../redux/corporateService'
import { useAppDispatch } from '../../../redux/storeExports'
import EmployeeTable from './EmployeeTable'
import EmployeeMobileView from './EmployeeMobileView'

export interface EmployeeRow {
  id: number
  col1: string
  col2: number
  col3: number
  col4: number
  col5: 'invited' | 'queued' | 'deleted' | 'accepted' | 'expired' | 'failed' | 'active'
  col6: string | null
  col8: string | null
  col9: string | null
}

const DashboardGrid = () => {
  const filteredEmployees = InvitedAndActiveEmployeesSelector()
  const rows: EmployeeRow[] = useMemo(() => (
    filteredEmployees
      .map((item, index) => ({
        id: index + 1,
        col1: item.email,
        col2: item.brokers_found,
        col3: item.brokers_removed,
        col4: item.brokers_in_progress,
        col5: item.invite_status,
        col6: item.billing_status,
        col8: item.muid,
        col9: item.last_scan_date,
      }))
      .filter((value, index, self) => (
        self.findIndex((item) => item.col1 === value.col1) === index
      ))
  ), [filteredEmployees])

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const dispatch = useAppDispatch()

  const [selectedStatus, setSelectedStatus] = useState('')
  const [selectedBillingStatus, setSelectedBillingStatus] = useState('')
  const [page, setPage] = useState(0)
  const [openMenuIndex, setOpenMenuIndex] = useState<number | null>(null)
  const [muidrow, setMuidRow] = useState<string | null>(null)
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  const [open, setOpen] = useState(false)
  const [detailsModalOpen, setDetailsModalOpen] = useState(false)
  const buttonRef = useRef<HTMLButtonElement>(null)
  const isOpen = Boolean(anchorEl)

  const [sortConfig, setSortConfig] = useState<{ key: string; direction: 'asc' | 'desc' }>({
    key: 'col2',
    direction: 'desc',
  })

  const handleSort = (columnKey: string) => {
    setSortConfig((prev) => (
      prev.key === columnKey
        ? { key: columnKey, direction: prev.direction === 'asc' ? 'desc' : 'asc' }
        : { key: columnKey, direction: 'asc' }
    ))
    setPage(0)
  }

  const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>, index: number) => {
    if (openMenuIndex === index) {
      setOpenMenuIndex(null)
      setAnchorEl(null)
    } else {
      setOpenMenuIndex(index)
      setAnchorEl(event.currentTarget)
      const clickedRow = rows.find((row) => row.id === index)
      setMuidRow(clickedRow?.col8 || null)
    }
  }

  const close = () => {
    setAnchorEl(null)
    setOpenMenuIndex(null)
    buttonRef.current?.focus()
  }

  const handleopen = () => setOpen(true)
  const handleDetailsModalOpen = () => setDetailsModalOpen(true)
  const handleMenuItemClick = (value: string) => {
    setSelectedStatus(value)
    setPage(0)
  }
  const handleBillingItemClick = (value: string) => {
    setSelectedBillingStatus(value)
    setPage(0)
  }
  console.log(rows)
  const filteredRows = rows.filter((row) => {
    const statusMatch = selectedStatus ? row.col5 === selectedStatus : true

    const billingMatch = selectedBillingStatus
      ? selectedBillingStatus === 'waiting'
        ? !row.col6 || row.col6 === 'waiting'
        : row.col6 === selectedBillingStatus
      : true

    return statusMatch && billingMatch
  })


  type SortableColumn = 'col2' | 'col3' | 'col4'
  const sortedRows = useMemo(() => {
    if (!sortConfig.key) return filteredRows
    const key = sortConfig.key as SortableColumn
    return [...filteredRows].sort((a, b) => (
      sortConfig.direction === 'asc' ? a[key] - b[key] : b[key] - a[key]
    ))
  }, [filteredRows, sortConfig])

  return (
    <ThemeProvider theme={theme}>
      {isMobile ? (
        <EmployeeMobileView
          rows={rows}
          openMenuIndex={openMenuIndex}
          anchorEl={anchorEl}
          isOpen={isOpen}
          handleButtonClick={handleButtonClick}
          close={close}
          handleopen={handleopen}
          open={open}
          setOpen={setOpen}
          muidrow={muidrow}
          buttonRef={buttonRef}
          dispatch={dispatch}
          resendInvite={resendInvite}
        />
      ) : (
        <EmployeeTable
          rows={rows}
          page={page}
          setPage={setPage}
          sortedRows={sortedRows}
          handleSort={handleSort}
          sortConfig={sortConfig}
          selectedStatus={selectedStatus}
          selectedBillingStatus={selectedBillingStatus}
          handleBillingItemClick={handleBillingItemClick}
          handleMenuItemClick={handleMenuItemClick}
          openMenuIndex={openMenuIndex}
          anchorEl={anchorEl}
          isOpen={isOpen}
          handleButtonClick={handleButtonClick}
          close={close}
          handleopen={handleopen}
          open={open}
          handleDetailsModalOpen={handleDetailsModalOpen}
          detailsModalOpen={detailsModalOpen}   
          setDetailsModalOpen={setDetailsModalOpen}
          setOpen={setOpen}
          muidrow={muidrow}
          dispatch={dispatch}
          resendInvite={resendInvite}
          buttonRef={buttonRef}
        />
      )}
    </ThemeProvider>
  )
}

export default DashboardGrid
